import { getBlockDefaultClassName } from '@wordpress/blocks';
import { Fragment } from "@wordpress/element";
import { InspectorControls, InnerBlocks, RichText } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";
import { PanelBody, ToggleControl } from '@wordpress/components';
import './style.scss';

const Slider = {
  title: __('Slider'),
  description: __('A responsive slider'),
  icon: 'format-gallery',
  attributes: {
    title : {
      type:   'string',
    },
    inverseStyling : {
      type: 'boolean',
      default: false,
    }
  },
  supports: {
    customClassName: false,
  },
  edit({ className, attributes, setAttributes }) {
    const { inverseStyling } = attributes;
    const { title } = attributes;
    const allowedBlocks = [ 'abs/content-slide-block' ];
    const toggleInverseStyling = () => {
      setAttributes( { inverseStyling: !inverseStyling } );
    };
    let classes = [ String(className) ];

    if (inverseStyling) {
      classes.push('inverted');
    }

    return (
      <Fragment>
        <div className={ classes.join(' ') }>
          <div className="container">
            <div className="row">
              <div className="col">
                <RichText
                  tagName="h2"
                  className="title"
                  value={ title }
                  placeholder={ __('Insert slider title') }
                  allowedFormats={[]}
                  onChange={ nextTitle => setAttributes({ title: nextTitle }) }
                />
              </div>
            </div>
            <div className="row">
              <div className="col slider">
                <InnerBlocks allowedBlocks={ allowedBlocks } />
              </div>
            </div>
          </div>
        </div>

        <InspectorControls>
          <PanelBody title={ __('Block Style') }>
            <ToggleControl
              label={ __('Invert colors') }
              help={ inverseStyling ? __('Inverted display') : __('Default display') }
              checked={ !! inverseStyling }
              onChange={ toggleInverseStyling }
            />
          </PanelBody>
        </InspectorControls>
      </Fragment>
    );
  },

  save({ attributes }) {
    const className = getBlockDefaultClassName( 'abs/content-slider-block' );
    const { inverseStyling } = attributes;
    const { title } = attributes;
    let classes = [ String(className) ];

    if (inverseStyling) {
      classes.push('inverted');
    }

    return (
      <div className={ classes.join(' ') }>
        <div className="container">
          {title && (
          <div className="row">
            <div className="col">
              <RichText.Content tagName="h2" value={ title } />
            </div>
          </div>
          )}
          <div className="row">
            <div className="col slider">
              <InnerBlocks.Content />
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default Slider;
